import _trimEnd from 'lodash/trimEnd';

module.exports = {
  path: ':id',
  indexRoute: {
    onEnter: (nextState, replace) => replace(`${_trimEnd(nextState.location.pathname, '/')}/information`),
  },
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/information'),
        require('./routes/devices'),
        require('./routes/rollouts'),
        require('./routes/deviceBatches'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DistributionShow'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/routes/show/index.js